<template>
  <v-container>

    <TaxWarrantsList/>

  </v-container>
</template>

<script>

import TaxWarrantsList from './TaxWarrantsList.vue';
import '../../../assets/style.css';

export default {
  name: 'TaxWarrants',
  components: {

    TaxWarrantsList,

  },
};
</script>

<style scoped>
.label {
  font-size: 0.85rem;
}
</style>
